import React, { Component } from 'react';
import { Heading, Table, Pane, Textarea, Badge } from 'evergreen-ui';
import './App.css';

class App extends Component {
  textareaExpandSize(e) {
    e.target.style.height = `${e.target.scrollHeight}px`;
  }
  render() {
    return (
      <div className="App">
        <Heading size={700} marginTop="default" marginBottom="default" Style="text-align: center;" contenteditable="true">SWOT Analysis</Heading>
        <Table Style="text-align: center;border-collapse: collapse;" marginLeft={10} marginRight={10} border={true}>
          <Table.Head height="auto">
            <Table.TextHeaderCell flexBasis={50} flexShrink={0} flexGrow={0} Style="border-collapse: collapse;border-right:">
              <Heading size={200} marginTop="default" marginBottom="default">SWOT</Heading>
            </Table.TextHeaderCell>
            <Table.TextHeaderCell>
              <Heading size={200} marginTop="default" marginBottom="default">Helpful<br></br>to achieving the objective</Heading>
            </Table.TextHeaderCell>
            <Table.TextHeaderCell>
              <Heading size={200} marginTop="default" marginBottom="default">Harmful<br></br>to achieving the objective</Heading>
            </Table.TextHeaderCell>
          </Table.Head>
          <Table.Body>
            <Table.Row height="auto" paddingY={12}>
              <Table.TextCell className="custom-span" flexBasis={50} flexShrink={0} flexGrow={0}>
                <Heading size={200} marginTop="default" marginBottom="default">Internal origin<br></br>(attributes of the organization)</Heading>
              </Table.TextCell>
              <Table.TextCell>
                <Pane width="100%" height="100%">
                  <Badge color="yellow" htmlFor="textarea-2" marginBottom={2} display="block" Style="text-align:left;">Strengths</Badge>
                  <Textarea id="textarea-2" height={200} onKeyDown={this.textareaExpandSize} className="custom-textarea"/>
                </Pane>
              </Table.TextCell>
              <Table.TextCell>
                <Pane width="100%" height="100%">
                  <Badge color="neutral" htmlFor="textarea-2" marginBottom={2} display="block" Style="text-align:left;">Weaknesses</Badge>
                  <Textarea id="textarea-2" height={200} onKeyDown={this.textareaExpandSize} className="custom-textarea"/>
                </Pane>
              </Table.TextCell>
            </Table.Row>
            <Table.Row height="auto" paddingY={12}>
              <Table.TextCell className="custom-span" flexBasis={50} flexShrink={0} flexGrow={0}>
                <Heading size={200} marginTop="default" marginBottom="default">External origin<br></br>(attributes of the environment)</Heading>
              </Table.TextCell>
              <Table.TextCell>
                <Pane width="100%" height="100%">
                  <Badge color="green" htmlFor="textarea-2" marginBottom={2} display="block" Style="text-align:left;">Opportunities</Badge>
                  <Textarea id="textarea-2" height={200} onKeyDown={this.textareaExpandSize} className="custom-textarea"/>
                </Pane>
              </Table.TextCell>
              <Table.TextCell>
                <Pane width="100%" height="100%">
                  <Badge color="red" htmlFor="textarea-2" marginBottom={2} display="block" Style="text-align:left;">Threats</Badge>
                  <Textarea id="textarea-2" height={200} onKeyDown={this.textareaExpandSize} className="custom-textarea"/>
                </Pane>
              </Table.TextCell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js